import { Fragment, useContext } from "react"
// import { ActionButton } from "../../../../../../../../components"
// import { CreateModal } from "../../../CreateModal"
import { ChildItem } from "../.."
import { Delete, Detail, Update, IsActive } from "./components"
import type { DataItem, DataList } from "../../../../types"
import { useToggle } from "../../../../../../../../utils"
import { TableNumber } from "components"
import { dataContext } from "pages/Setup/Preference/Religion"

export function Item(props: { item: DataList, index: number, dataList: DataItem, refetch: () => void}) {
  const { isActive } = useToggle(false)
  const { currentPage, limit, size, total} = useContext(dataContext)

  return (
    <Fragment>
      <tr>
        <td>{TableNumber({dataLength: size, pageCurrent: currentPage, index: props.index, limit: limit, totalData: total})}</td>
        <td>{props.item.religion_code}</td>
        <td>{props.item.religion_name}</td>
        <td>{props.item.description}</td>
        <td>
        <div className="flex items-center">
          <Detail id={props.item} />
          <Update id={props.item} refetch={props.refetch} />
          <Delete id={props.item} refetch={props.refetch} />
          <IsActive id={props.item} refetch={props.refetch} />
          </div>
        </td>
      </tr>
      {isActive && <ChildItem dataList={props.dataList} refetch={props.refetch} />}
    </Fragment>
  )
}